import React from 'react';

const Nearshoring = ({ t }) => {
  return (
    <section id="nearshoring" data-testid="nearshoring-section" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-5 sm:px-6 lg:px-8 max-w-6xl">
        {/* Two-column layout with image on desktop */}
        <div className="lg:grid lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            {/* Header */}
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-light text-gray-900 mb-3 leading-snug">
              {t.nearshoring.title}
            </h2>
            <p className="text-sm text-gray-500 mb-8 lg:mb-10">
              {t.nearshoring.subtitle}
            </p>
            
            {/* Context */}
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-8">
              {t.nearshoring.context}
            </p>
            
            {/* Key Points */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 mb-10">
              {t.nearshoring.points.map((point, index) => (
                <div key={`point-${point.slice(0, 20)}`} className="flex items-start gap-2.5">
                  <div className="w-1 h-1 bg-gray-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-sm text-gray-600">{point}</span>
                </div>
              ))}
            </div>
            
            {/* Positioning Statement */}
            <div className="border-l-2 border-gray-300 pl-5 sm:pl-6">
              <p className="text-sm text-gray-700 leading-relaxed">
                {t.nearshoring.positioning}
              </p>
            </div>
          </div>
          
          {/* Image - Desktop only */}
          <div className="hidden lg:block lg:col-span-5">
            <img
              src="/images/renders/He_004.jpg"
              alt="Hexaparks logistics gateway"
              className="w-full h-full object-cover rounded-sm border border-gray-200"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Nearshoring;
